import { action } from 'satcheljs';
import type AccountAuthState from '../store/schema/AccountAuthState';
import type { IdentityInfo } from 'owa-auth-types';

export interface SetAccountAuthStateActionMessage {
    identityInfo: IdentityInfo;
    authState: AccountAuthState;
}
const defaultExport: (
    identityInfo: IdentityInfo,
    authState: AccountAuthState
) => SetAccountAuthStateActionMessage = action(
    'setAccountAuthState',
    (
        identityInfo: IdentityInfo,
        authState: AccountAuthState
    ): SetAccountAuthStateActionMessage => ({
        identityInfo,
        authState,
    })
);
export default defaultExport;
